import { Autocomplete, TextField, CircularProgress } from '@mui/material';
import { useEffect, useState } from 'react';
import fetchRequest from '@libs/fetchRequest';

const SelectCalendar = ({ value, onChange, sx }) => {
    const [calendars, setCalendars] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        fetchCalendars();
    }, []);

    const fetchCalendars = async () => {
        try {
            setIsLoading(true);
            const response = await fetchRequest('/calender/get/all', 'GET');

            if (response && response.data) {
                const calendarOptions = response.data.map((calendar) => ({
                    id: calendar.id,
                    name: calendar.name
                }));
                setCalendars(calendarOptions);
            }
        } catch (error) {
            console.error('Failed to fetch calendars:', error);
            setCalendars([]);
        } finally {
            setIsLoading(false);
        }
    };

    // Find the selected calendar by id
    const selectedCalendar = value !== undefined
        ? calendars.find((c) => c.id === value) || null
        : null;

    return (
        <Autocomplete
            size='small'
            sx={{
                minWidth: 180,
                width: 180,
                '& .MuiInputBase-root': {
                    backgroundColor: 'transparent',
                    height: '36px'
                },
                ...sx
            }}
            componentsProps={{
                paper: {
                    sx: {
                        '& .MuiAutocomplete-option': {
                            fontSize: '0.875rem'
                        }
                    }
                }
            }}
            options={calendars}
            getOptionLabel={(option) => option?.name || ''}
            value={selectedCalendar}
            onChange={(event, newValue) => {
                onChange(newValue ? newValue.id : null);
            }}
            loading={isLoading}
            disableCloseOnSelect={false}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label='Calendar'
                    placeholder='Select calendar'
                    sx={{
                        '& .MuiInputBase-root': {
                            backgroundColor: 'transparent'
                        },
                        '& .MuiInputBase-input': { 
                            fontSize: '0.875rem',
                            backgroundColor: 'transparent'
                        },
                        '& .MuiInputLabel-root': { fontSize: '0.875rem' },
                        '& .MuiOutlinedInput-root': {
                            backgroundColor: 'transparent'
                        }
                    }}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {isLoading ? (
                                    <CircularProgress
                                        color='inherit'
                                        size={20}
                                    />
                                ) : null}
                                {params.InputProps.endAdornment}
                            </>
                        )
                    }}
                />
            )}
        />
    );
};

export default SelectCalendar;
